/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Extraction_Complete_UploadingInputs */



/**
* | output |
* | --- |
* | "Audio extraction complete. Uploading..." |
*
* @param {Audio_Extraction_Complete_UploadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_extraction_complete_uploading = /** @type {((inputs?: Audio_Extraction_Complete_UploadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Extraction_Complete_UploadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Extraction audio terminée. Téléversement...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audioextraktion abgeschlossen. Upload läuft...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Estrazione audio completata. Caricamento in corso...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Извлечение аудио завершено. Загрузка...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Extracción de audio completada. Subiendo...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("音频提取完成。正在上传……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオの抽出が完了しました。アップロードしています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो एक्सट्रैक्शन पूरा हो गया है। अपलोड हो रहा है...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Extração de áudio concluída. Enviando...")
	return /** @type {LocalizedString} */ ("Audio extraction complete. Uploading...")
});